export enum LearningPathStatus {
  draft = 0,
  published = 1,
}
